import Glide from "@glidejs/glide";

const initPlayPauseButton = (playPauseButton: HTMLButtonElement, glide: Glide) => {
    if (playPauseButton && glide) {
        playPauseButton.addEventListener('click', () => {
            if (playPauseButton.title === 'Pause') {
                glide.pause();
                playPauseButton.title = 'Play';
                playPauseButton.setAttribute('aria-label', 'Play');
                playPauseButton.firstElementChild?.classList.add('hidden');
                playPauseButton.lastElementChild?.classList.remove('hidden');
            } else {
                glide.play();
                playPauseButton.title = 'Pause';
                playPauseButton.setAttribute('aria-label', 'Pause');
                playPauseButton.firstElementChild?.classList.remove('hidden');
                playPauseButton.lastElementChild?.classList.add('hidden');
            }
        });
    }
};

const initSlideAttributes = (activeSlide: HTMLElement, slideClones: NodeListOf<HTMLElement>) => {
    if (activeSlide) {
        activeSlide.tabIndex = 0;
        activeSlide.querySelectorAll('a').forEach(link => link.tabIndex = 0);
    }

    slideClones.forEach(slideClone => {
        slideClone.removeAttribute('id');
        slideClone.setAttribute('aria-hidden', 'true');
        slideClone.removeAttribute('role');
        slideClone.tabIndex = -1;
        slideClone.querySelector('.text-wrap')?.remove();
    });
};

const initCarouselPauseOnFocus = (carousel: HTMLElement, glide: Glide, glidePauseButton: HTMLButtonElement) => {
    if (carousel && glide) {
        carousel.addEventListener('focusin', () => {
            glide.pause();
            if (glidePauseButton) {
                glidePauseButton.title = 'Play';
                glidePauseButton.setAttribute('aria-label', 'Play');
                glidePauseButton.firstElementChild?.classList.add('hidden');
                glidePauseButton.lastElementChild?.classList.remove('hidden');
            }
        });
    }
};

const initArrowButtonNavigation = (buttons: NodeListOf<HTMLButtonElement>, glide: Glide) => {
    Array.from(buttons).forEach(button => {
        button.addEventListener('keydown', event => {
            if (event.key === 'ArrowLeft') {
                event.preventDefault();
                glide.go('<');
            } else if (event.key === 'ArrowRight') {
                event.preventDefault();
                glide.go('>');
            }
        });
    });
};

const initGlideSlideChangeHandler = (glide: Glide, slides: NodeListOf<HTMLElement>, bullets: NodeListOf<HTMLButtonElement>) => {
    if (glide) {
        glide.on('run', () => {
            Array.from(slides).forEach((slide, index) => {
                slide.tabIndex = -1
                slide.querySelectorAll('a').forEach(link => link.tabIndex = index !== glide.index ? -1 : 0);
            });
            slides[glide.index].tabIndex = 0;
            bullets.forEach(bullet => bullet.tabIndex = -1);
            bullets[glide.index].tabIndex = 0;
        });

        glide.on('run.after', () => {
            if (Array.from(slides).some(slide => slide === document.activeElement || slide.contains(document.activeElement))) {
                slides[glide.index].focus();
            } else if (Array.from(bullets).some(bullet => bullet === document.activeElement)) {
                bullets[glide.index].focus();
            }
        });
    }
};

export const initBannerGlide = (slidesPerView: number = 1.68, gap: number = 1) => {
    const glideContainer = document.querySelector('.glide') as HTMLElement | null;
    const slides: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.glide .glide__slide');

    if (glideContainer && slides.length > 1) {
        const glide = new Glide(glideContainer, {
            type: 'carousel',
            gap,
            autoplay: 6500,
            keyboard: false,
            hoverpause: true,
            focusAt: 'center',
            perView: slidesPerView,
            breakpoints: {
                767: {
                    perView: 1
                }
            }             
        });

        glide.on('mount.after', () => {
            const glidePauseButton: HTMLButtonElement | null = document.querySelector('.glide__pause');
            const activeSlide: HTMLElement | null = document.querySelector('.glide__slide--active');
            const slideClones: NodeListOf<HTMLElement> = document.querySelectorAll('.glide__slide--clone');
            const carousel: HTMLElement | null = document.querySelector('.glide__track');
            const bullets: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.glide__bullets .glide__bullet');
            const prevNextButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.glide-arrows button');

            if (glidePauseButton && activeSlide && carousel) {
                initPlayPauseButton(glidePauseButton, glide);
                initSlideAttributes(activeSlide, slideClones);
                initCarouselPauseOnFocus(carousel, glide, glidePauseButton);
                initArrowButtonNavigation(slides, glide);
                initArrowButtonNavigation(bullets, glide);
                initArrowButtonNavigation(prevNextButtons, glide);
                initGlideSlideChangeHandler(glide, slides, bullets);
            }
        });

        glide.mount();
    }
};